/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsCommonDeviceInfo } from './common.model';

export interface FirmwareUpdateDialogLaunchedEvent {
	location: FirmwareUpdateLocation;
	device_count: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface FirmwareUpdateDialogCancelledEvent {}

export interface FirmwareUpdateSubmittedEvent {
	location: FirmwareUpdateLocation;
	event_sub_type: FirmwareUpdateType;
	devices: FirmwareUpdateDeviceInfo[];
}

export interface FirmwareUpdateRemovedEvent {
	location: FirmwareUpdateLocation;
	device: AnalyticsCommonDeviceInfo;
}

export enum FirmwareUpdateLocation {
	PropertiesPanel = 'properties_panel',
	InventoryView = 'inventory_view',
	InventoryTable = 'inventory_table'
}

export enum FirmwareUpdateType {
	Immediate = 'immediate',
	Scheduled = 'scheduled'
}

export interface FirmwareUpdateDeviceInfo
	extends Pick<AnalyticsCommonDeviceInfo, 'model' | 'mac' | 'serial' | 'hardware_id'> {
	old_firmware_package_version: string;
	new_firmware_package_version: string;
	new_firmware_package_key: string;
	hosted: boolean;
}
